exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dropdown .dropdown-menu[data-v-6331f7fa]{width:350px}.dropdown .dropdown-menu .note[data-v-6331f7fa]{overflow-y:auto;max-height:200px}", ""]);

// exports
